import { setStaticContentLoading } from 'libs/router/staticContentLoadingSignal';

import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect';

/**
 * `loading` fallback for every registry.tsx dynamic() entry. Renders nothing
 * visible itself — StaticPageRoute hides the whole page (header, content,
 * footer) while this is mounted, so only the top RouteProgress bar shows;
 * this component's one job is to hold that state via staticContentLoading
 * Signal (set on mount, cleared on unmount, i.e. once the real page content
 * has taken its place) so header+content+footer reveal together in one
 * moment instead of the header/footer showing first.
 *
 * useLayoutEffect (not useEffect) so the signal flips before the browser
 * paints — otherwise the page would flash visible for one frame first.
 * Never mounts on a fresh full page load: dynamic() defaults to ssr:true, so
 * the real content is already in the server-rendered HTML in that case.
 */
export const StaticPageLoading = () => {
  useIsomorphicLayoutEffect(() => {
    setStaticContentLoading(true);

    return () => setStaticContentLoading(false);
  }, []);

  return null;
};
